import { useShowError } from "@/modules/error/useShowError.ts";
import { useSearch } from "@tanstack/react-router";
import { useMemo } from "react";
import type z from "zod";

/** Parse value with Zod schema and show error if parsing fails */
export function useZodParse<T>(schema: z.ZodType<T>, value: unknown, message = "Error parsing schema") {
    const { error, data } = useMemo(() => schema.safeParse(value), [schema, value]);
    useShowError(error, message);
    return data;
}

/** Validate query parameters with Zod for safety (against eg. invalid value injection) and better typing */
export function useZodSearchParams<T>(schema: z.ZodType<T>) {
    const rawSearch = useSearch({ strict: false });
    return useZodParse(schema, rawSearch, "Error parsing search params");
}
